exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kevin[data-v-6b37e353]{width:200px;height:auto}h1[data-v-6b37e353],h2[data-v-6b37e353],h3[data-v-6b37e353]{margin:0;font-weight:400}h1[data-v-6b37e353],h2[data-v-6b37e353]{font-size:7vmin!important}h3[data-v-6b37e353]{font-size:5vmin!important}.bottom-border[data-v-6b37e353]{display:inline-block;padding-bottom:20px;border-bottom:6px solid #f26721;margin-bottom:10px}", ""]);

// exports
